import { Box, Button, HStack, VStack } from '@bpba/ui-components';
import { FC } from 'react';
import { Spinner } from '../shared/Spinner';
import { EMAIL_MAX_LENGTH } from '../../constants/form';
import { FormularioOtp } from '../shared/otp/FormularioOtp';
import { useLoginManager } from './useLoginManager';
import { ErrorMessageContainer } from '../shared/ErrorMessageContainer';
import { BPFormProvider, Input } from '@bpba/form-components';
import { LoginRules } from './LoginRules';
import { Titulo } from '../shared/Titulo';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

export const LoginComponent: FC = () => {
  const [isLoading, isRequestError, requestErrorMessage, emailBlocked, showEmail, showOTP, showConfirmButton, confirm, otp, setOtp, showErrorOtp, form] = useLoginManager();
  const navigate = useNavigate();

  const confirmMessage = showOTP ? 'Confirmar' : 'Enviar';

  return (
    <>
      <Titulo>Ingresar</Titulo>
      {isLoading && <Spinner width={40} my={'48px'} />}
      <VStack display={showEmail ? 'flex' : 'none'} aria-hidden={emailBlocked}>
        <BPFormProvider methods={form} rules={LoginRules}>
          <Input
            name="email"
            control={form.control}
            placeholder="Correo (ej.: ejemplo@correo.org.ar)"
            readOnly={emailBlocked}
            required={true}
            maxLength={EMAIL_MAX_LENGTH}
            label="Ingresá tu correo"
          />
        </BPFormProvider>
      </VStack>

      {showOTP && <FormularioOtp otp={otp} setOtp={setOtp} ariaHidden={false} showError={showErrorOtp} />}

      <ErrorMessageContainer show={isRequestError} errorMessage={requestErrorMessage} />

      <HStack>
        <Button mt={'8px !important'} variant="secondary" display={showConfirmButton ? 'unset' : 'none'} onClick={confirm}>
          {confirmMessage}
        </Button>
      </HStack>
      <StyledLink
        width={'fit auto'}
        margin={'auto'}
        mt={'48px'}
        color={'primary.0'}
        onClick={() => {
          navigate('/registro');
        }}
      >
        Registro
      </StyledLink>
    </>
  );
};

const StyledLink = styled(Box)({
  ':hover': {
    cursor: 'pointer',
  },
});
